// extracted by mini-css-extract-plugin
module.exports = {"container":"l_c","video":"l_K"};